import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForFunctionReferencen3g5fpj34t8u as initMetadataForFunctionReference,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  awaitqeg6zusi9ora as await_0,
  await1kke5zj2piplv as await_1,
  awaitOnce2ui7qqi9bvdeq as awaitOnce,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import {
  modify2eca96i8s7hc2 as modify,
  set_value1vvx5pkb20ebv as set_value,
} from '../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import {
  get_rawSession1kjo1nj4tz6n0 as get_rawSession,
  get_session9cytjmfbg8nd as get_session,
  get_sessionToken1e5yonv6d457l as get_sessionToken,
} from '../../../sdk/UserSession.mjs';
import { pushChanges1lnw8bjwewvzf as pushChanges } from '../../../utils/Draft.ext.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  get_pageNavigator1inl9j7ja0vlf as get_pageNavigator,
  get_mainPageNavigator29w1pddlp5wea as get_mainPageNavigator,
  get_dialogPageNavigator3pxggbj34kkoa as get_dialogPageNavigator,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { ContractorNewRegistration1u860bdbb1seh as ContractorNewRegistration } from './NewContractorRegistration.mjs';
import {
  get_selectedApi2skzkr2pn0lot as get_selectedApi,
  getDefaultServerBackend2jor6mvf4ze21 as getDefaultServerBackend,
  get_entries12jrtr1kr2cjq as get_entries,
} from '../../../sdk/apiOptions.mjs';
import {
  LoginEmailRequest1l3a375d4eoce as LoginEmailRequest,
  Flavor_ContractorRegistration_getInstancegyu38r35kycq as Flavor_ContractorRegistration_getInstance,
  RegisterContractortxxdpjweklvo as RegisterContractor,
  Addresscpovxna1tjmg as Address,
} from '../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  Contractor1wog4uk4l8u77 as Contractor,
  User8yb1tqk4kykg as User,
  Type_ContractorTermsAndConditions_getInstance35f4ps0n3qx14 as Type_ContractorTermsAndConditions_getInstance,
  Type_PrivacyPolicy_getInstanceywyaqmy6sd2 as Type_PrivacyPolicy_getInstance,
} from '../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { get_selectedContractor2m4vxuqdzv6k3 as get_selectedContractor } from '../../../selectedContractor.mjs';
import { delayolwo40i9ucjz as delay } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { LandingScreennv9edtrim3be as LandingScreen } from '../common/LandingScreen.mjs';
import {
  Exceptiondt2hlxn7j7vw as Exception,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { ModificationBuilderuhgnvnxpchbi as ModificationBuilder } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ModificationBuilder.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import { get_sendNotifications3liu60yge341n as get_sendNotifications } from '../../../../../../crowpay-shared/com/crowpay/UserFields.mjs';
import {
  FinishProoflhqad7xhem5u as FinishProof,
  Proof19kcc739cbo52 as Proof,
} from '../../../../../../lightning-server-shared/com/lightningkite/lightningserver/auth/proof/proofModels.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { GenericDialog2kroovzplfo3s as GenericDialog } from '../../dialogs/GenericDialog.mjs';
import { get_AutoRoutes3nqqi7p59slz8 as get_AutoRoutes } from '../../autoroutes.mjs';
import { ViewLegalDocument2rrxowcqg42d as ViewLegalDocument } from '../common/ViewLegalDocument.mjs';
import {
  listOf1jh22dvmctj1r as listOf_0,
  emptyList1g2z5xcrvp2zy as emptyList,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { SharedUtils_getInstanceggolgle4lzs6 as SharedUtils_getInstance } from '../../../../../../crowpay-shared/com/crowpay/sharedUtils.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { ViewWriter2xfqkrnuqv5cx as ViewWriter } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/ViewWriter.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { Draftj5auffrm1u2b as Draft } from '../../../../../../reactive/com/lightningkite/reactive/core/Draft.mjs';
import { validated2q9ie09qg9r46 as validated } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/ValidatedDraft.mjs';
import {
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance,
  Companion_getInstance2v0f9t0g75gcs as Companion_getInstance_0,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
  Dimensions32ju1l7z4mh as Dimension,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import {
  Frame1e7t2kcdb3wu7 as Frame,
  RowOrCol3a33s3yce2tuv as RowOrCol,
  RowCollapsingToColumn13iucsgmjquhb as RowCollapsingToColumn,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { shownWhenxgf1ujy6rmvr as shownWhen } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  title1nssp3ryhwuqj as title,
  boldSubTitle1bjbn9bt8inbw as boldSubTitle,
  body3i5t0n7zprpqb as body,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  SmallBodySemantic_getInstance13vsg4635cu56 as SmallBodySemantic_getInstance,
  smallBody2trfy14zwtona as smallBody,
} from '../../theming/Titles.mjs';
import {
  get_contactFirstName4zsaw4v0liuh as get_contactFirstName,
  get_contactLastNamehzwltosy6qkq as get_contactLastName,
  get_contactEmail1hq0is5lnk4tx as get_contactEmail,
  get_contactPhoneNumberlh8nl8hy5d06 as get_contactPhoneNumber,
  get_name166ebenv7vstz as get_name,
  get_legalName1h459s03czxpi as get_legalName,
} from '../../../../../../crowpay-shared/com/crowpay/ContractorFields.mjs';
import { lensPath16mstx1fbm6dz as lensPath } from '../../../../../../lightning-server-kiteui-client/com/lightningkite/serialization/MutableReactive.lens.DataClassPath.mjs';
import {
  assertNotBlank3rcqh0n27fq5q as assertNotBlank,
  assert3pektuc8qw5gc as assert,
} from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/helpers.mjs';
import { validategsg6go7eyi9d as validate } from '../../../utils/validation.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import {
  requiredField31yu7ndxhpyxkd as requiredField3,
  label287uhiq3m9m4z as label2,
} from '../../components/label2.mjs';
import { PhoneNumberInput1tdzv8kpf7vme as PhoneNumberInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/PhoneNumberInput.mjs';
import { greySeparatory5mpcoeivng5 as greySeparator } from '../../theming/separators.mjs';
import { get_centered1xfu6or5nc0lq as get_centered } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { RadioButton1rpamcjl5aybg as RadioButton } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/RadioButton.commonHtml.mjs';
import {
  equalTo2dio0vrcsd3je as equalTo,
  notNull1cr24slx2d4vw as notNull,
} from '../../../../../../reactive/com/lightningkite/reactive/extensions/commonLenses.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import {
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  get_textButtonybbt8y3eu5hx as get_textButton,
} from '../../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  reactiveScope1fcalsbdr0hgb as reactiveScope,
  reactive2pl1t9wy5gll5 as reactive,
} from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { errorTextv58wi1t0me7u as errorText } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import {
  get_rem14pbkv8p42gid as get_rem,
  get_dp28ag147e4p5cz as get_dp,
  get_rem2p56fiaxda5jo as get_rem_0,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../theming/AppColors.mjs';
import { colored3y8uibz1hk46 as colored } from '../../theming/colorManagement.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { EmailProof3rgt8vdvz5buo as EmailProof } from './EmailProof.mjs';
import { render38qn7o0b2bza2 as render } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Routes.mjs';
import { mutableRemember1h6fyyolumj0o as mutableRemember } from '../../../../../../reactive/com/lightningkite/reactive/core/MutableRemember.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import {
  FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance,
  CardSemantic_getInstance24h7hf3qltxfl as CardSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import { resize3py5p2yrjp6p7 as resize } from '../../../utils/utils.mjs';
import { AuthBackgroundSemantic_getInstance55rb2qz6vrk4 as AuthBackgroundSemantic_getInstance } from '../../theming/auth.mjs';
import {
  get_scrolling27q1yr4ng0cx8 as get_scrolling,
  get_padded3m3frjnjujncx as get_padded,
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { applySafeInsets3lsxkfxcwtdd8 as applySafeInsets } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/safeInsetsHelpers.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../components/nav/AppDimensions.mjs';
import {
  AuthDialogSemantic_getInstancetw8ua0jubs3m as AuthDialogSemantic_getInstance,
  get_appThemejy2o9bdilpry as get_appTheme,
} from '../../theming/appTheme.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ImageViewadm9fg4ms58f as ImageView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ImageView.mjs';
import { Resources_getInstance2tvlmekcueurd as Resources_getInstance } from '../../../Resources.js.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AuthScreenClass;
function AuthScreen() {
  if (AuthScreenClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'AuthScreen');
    AuthScreenClass = $;
  }
  return AuthScreenClass;
}
function *_generator_invoke__zhh2q8($this, $this$Action, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.oip_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (tmp) {
    var tmp_0 = modify($this.pip_1, LogInScreen$registerForm$slambda$slambda_0(), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = get_rawSession();
  var tmp_1 = await_1(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  if (tmp_1 == null) {
    var tmp_2 = $this.pip_1.bak($completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = get_selectedApi();
    var tmp_3 = await_0(this_2, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    var tmp_4 = tmp_3.dfx().dfh_1;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_3 = $this.pip_1;
    var tmp_5 = await_1(this_3, $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    // Inline function 'kotlin.let' call
    var it = tmp_5;
    var tmp$ret$5 = LoginEmailRequest().b9y(it.e5j_1, it.f5j_1, it.g5j_1, Flavor_ContractorRegistration_getInstance());
    var tmp_6 = tmp_4.ifs(tmp$ret$5, $completion);
    if (tmp_6 === get_COROUTINE_SUSPENDED())
      tmp_6 = yield tmp_6;
    var tmp_7 = $this.qip_1.iah(tmp_6, $completion);
    if (tmp_7 === get_COROUTINE_SUSPENDED())
      tmp_7 = yield tmp_7;
  } else {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_4 = get_session();
    var tmp_8 = await_1(this_4, $completion);
    if (tmp_8 === get_COROUTINE_SUSPENDED())
      tmp_8 = yield tmp_8;
    var tmp$ret$6 = tmp_8;
    var tmp_9 = pushChanges($this.pip_1, tmp$ret$6.lfv_1, $completion);
    if (tmp_9 === get_COROUTINE_SUSPENDED())
      tmp_9 = yield tmp_9;
    get_pageNavigator($this.rip_1).fbw(new (ContractorNewRegistration())());
  }
  return Unit_instance;
}
var LogInScreen$registerForm$slambda$slambdaClass;
function LogInScreen$registerForm$slambda$slambda() {
  if (LogInScreen$registerForm$slambda$slambdaClass === VOID) {
    class $ {
      sip(it, $completion) {
        return it.w5j(VOID, VOID, VOID, it.v5i_1);
      }
      s2(p1, $completion) {
        return this.sip(p1 instanceof Contractor() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    LogInScreen$registerForm$slambda$slambdaClass = $;
  }
  return LogInScreen$registerForm$slambda$slambdaClass;
}
function LogInScreen$registerForm$slambda$slambda_0() {
  var i = new (LogInScreen$registerForm$slambda$slambda())();
  var l = (it, $completion) => i.sip(it, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var tmp = $this.tip_1.iah(false, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_selectedApi();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.dfx().dfh_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.uip_1;
  var tmp_1 = await_1(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  // Inline function 'kotlin.let' call
  var it = tmp_1;
  var tmp$ret$3 = LoginEmailRequest().b9y(it.e5j_1, it.f5j_1, it.g5j_1, Flavor_ContractorRegistration_getInstance());
  var tmp_2 = tmp_0.ifs(tmp$ret$3, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return tmp_2;
}
function *_generator_invoke__zhh2q8_2($this, $completion) {
  var tmp = $this.vip_1.iah(null, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_3($this, proof, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_selectedApi();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var api = tmp.dfx();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.wip_1;
  var tmp_0 = await_1(this_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp$ret$1 = tmp_0;
  var tmp_1 = api.off_1.vfi(new (RegisterContractor())(tmp$ret$1, proof), $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp_2 = api.dfh_1.uei(listOf(proof), $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var session = tmp_2;
  var tmp_3 = get_sessionToken().iah(ensureNotNull(session.l4k_1), $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var tmp_4 = get_selectedContractor();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = $this.wip_1;
  var tmp_5 = await_1(this_2, $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  var tmp$ret$2 = tmp_5;
  var tmp_6 = tmp_4.iah(tmp$ret$2.t5i_1, $completion);
  if (tmp_6 === get_COROUTINE_SUSPENDED())
    tmp_6 = yield tmp_6;
  var tmp_7 = delay(100n, $completion);
  if (tmp_7 === get_COROUTINE_SUSPENDED())
    tmp_7 = yield tmp_7;
  get_mainPageNavigator($this.xip_1).fbw(new (ContractorNewRegistration())());
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_4($this, $this$Action, $completion) {
  var tmp = await_0(get_selectedApi(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.dfx().uff_1;
  var tmp_1 = await_0($this.zip_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp_2 = tmp_0.gei(tmp_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  $this.yip_1.oam(tmp_2);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_5($this, $completion) {
  var tmp = $this.aiq_1.jev_1.iah(true, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_6($this, $this$Action, $completion) {
  var tmp = emailLogin$confirmPasscode($this.biq_1, $this.ciq_1, $this.diq_1, $this.eiq_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_7($this, $this$launch, $completion) {
  var tmp = $this.fiq_1.iah(true, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = delay(3000n, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = $this.fiq_1.iah(false, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_8($this, $completion) {
  var tmp = await_0(get_selectedApi(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.dfx().uff_1;
  var tmp_1 = awaitOnce($this.hiq_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp_2 = tmp_0.gei(tmp_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  $this.giq_1.oam(tmp_2);
  $this.iiq_1.oam('');
  var tmp_3 = get_AppScope();
  launch(tmp_3, VOID, VOID, LogInScreen$emailLogin$slambda$slambda_0($this.jiq_1));
  return Unit_instance;
}
var LogInScreen$emailLogin$slambda$slambdaClass;
function LogInScreen$emailLogin$slambda$slambda() {
  if (LogInScreen$emailLogin$slambda$slambdaClass === VOID) {
    class $ {
      constructor($showIcon) {
        this.fiq_1 = $showIcon;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_7.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    LogInScreen$emailLogin$slambda$slambdaClass = $;
  }
  return LogInScreen$emailLogin$slambda$slambdaClass;
}
function LogInScreen$emailLogin$slambda$slambda_0($showIcon) {
  var i = new (LogInScreen$emailLogin$slambda$slambda())($showIcon);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_9($this, $completion) {
  var tmp = $this.kiq_1.iah(null, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.liq_1.iah('', $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_10($this, $this$Action, $completion) {
  var tmp = phoneLogin$confirmPasscode($this.miq_1, $this.niq_1, $this.oiq_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_11($this, $this$launch, $completion) {
  var tmp = $this.piq_1.iah(true, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = delay(3000n, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = $this.piq_1.iah(false, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_12($this, $completion) {
  var tmp = await_0(get_selectedApi(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.dfx().yfg_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.qiq_1.hev_1;
  var tmp_1 = await_0(this_0, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp0_safe_receiver = tmp_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.x4i_1;
  var tmp_2;
  if (tmp1_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_2 = tmp1_elvis_lhs;
  }
  var tmp_3 = tmp_0.pei(tmp_2, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  $this.qiq_1.iev_1.oam(tmp_3);
  $this.riq_1.oam('');
  var tmp_4 = get_AppScope();
  launch(tmp_4, VOID, VOID, LogInScreen$phoneLogin$slambda$slambda_0($this.siq_1));
  return Unit_instance;
}
var LogInScreen$phoneLogin$slambda$slambdaClass;
function LogInScreen$phoneLogin$slambda$slambda() {
  if (LogInScreen$phoneLogin$slambda$slambdaClass === VOID) {
    class $ {
      constructor($showIcon) {
        this.piq_1 = $showIcon;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_11.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    LogInScreen$phoneLogin$slambda$slambdaClass = $;
  }
  return LogInScreen$phoneLogin$slambda$slambdaClass;
}
function LogInScreen$phoneLogin$slambda$slambda_0($showIcon) {
  var i = new (LogInScreen$phoneLogin$slambda$slambda())($showIcon);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_13($this, $this$launch, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_rawSession();
  var tmp = await_1(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_elvis_lhs = tmp;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var session = tmp_0;
  try {
    var tmp_1 = session.vfw().dfh_1.aej($completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    if (!($this.tiq_1.fev_1 == null)) {
      get_pageNavigator($this.uiq_1).gbw(ensureNotNull($this.tiq_1.fev_1));
    } else {
      get_pageNavigator($this.uiq_1).gbw(new (LandingScreen())());
    }
  } catch ($p) {
    if ($p instanceof Exception()) {
      var e = $p;
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_14($this, $this$GenericDialog, $completion) {
  var tmp = $this.viq_1.gev_1.iah(null, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.viq_1.hev_1.iah(null, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function *_generator_finishLogin__x2wmg2($this, _this__u8e3s4, $completion) {
  var tmp = delay(2000n, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_rawSession();
  var tmp_0 = await_1(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp0_safe_receiver = tmp_0;
  var tmp_1;
  if (tmp0_safe_receiver == null) {
    tmp_1 = null;
  } else {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = tmp0_safe_receiver.rfw_1;
    var tmp_2 = await_1(this_1, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    tmp_1 = tmp_2;
  }
  var tmp1_safe_receiver = tmp_1;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    if (!tmp1_safe_receiver.r88_1) {
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_2 = get_session();
      var tmp_3 = await_1(this_2, $completion);
      if (tmp_3 === get_COROUTINE_SUSPENDED())
        tmp_3 = yield tmp_3;
      // Inline function 'com.crowpay.utils.modify2' call
      var this_3 = tmp_3.afw_1.geo(tmp1_safe_receiver.d88_1);
      // Inline function 'com.lightningkite.lightningdb.modification' call
      // Inline function 'kotlin.apply' call
      var this_4 = new (ModificationBuilder())();
      // Inline function 'com.lightningkite.lightningdb.path' call
      // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
      var tmp_4 = serializerOrContextual(createKType(getKClass(User()), arrayOf([]), false));
      var tmp$ret$3 = isInterface(tmp_4, KSerializer()) ? tmp_4 : THROW_CCE();
      var it = new (DataClassPathSelf())(tmp$ret$3);
      this_4.c44(get_sendNotifications(it), true);
      var tmp$ret$8 = this_4.m1r();
      var tmp_5 = this_3.nen(tmp$ret$8, $completion);
      if (tmp_5 === get_COROUTINE_SUSPENDED())
        tmp_5 = yield tmp_5;
    }
  }
  var tmp_6 = get_pageNavigator(_this__u8e3s4);
  var tmp2_elvis_lhs = $this.fev_1;
  tmp_6.gbw(tmp2_elvis_lhs == null ? new (LandingScreen())() : tmp2_elvis_lhs);
  return Unit_instance;
}
function *_generator_emailLogin$confirmPasscode__54fdz3(secret, passcode, this$0, $this_emailLogin, $completion) {
  var tmp = await_0(get_selectedApi(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var api = tmp.dfx();
  var tmp_0 = awaitOnce(secret, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp0_elvis_lhs = tmp_0;
  var tmp_1;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_1 = tmp0_elvis_lhs;
  }
  var tmp_2 = tmp_1;
  var tmp_3 = awaitOnce(passcode, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var tmp_4 = api.uff_1.iei(new (FinishProof())(tmp_2, tmp_3), $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  var proof = tmp_4;
  var tmp_5 = api.dfh_1.uei(listOf(proof), $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  var session = tmp_5;
  if (!(session.l4k_1 == null)) {
    var tmp_6 = get_sessionToken().iah(ensureNotNull(session.l4k_1), $completion);
    if (tmp_6 === get_COROUTINE_SUSPENDED())
      tmp_6 = yield tmp_6;
    var tmp_7 = this$0.wiq($this_emailLogin, $completion);
    if (tmp_7 === get_COROUTINE_SUSPENDED())
      tmp_7 = yield tmp_7;
  } else {
    var tmp0 = session.j4k_1;
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.none' call
      var tmp_8;
      if (isInterface(tmp0, Collection())) {
        tmp_8 = tmp0.i1();
      } else {
        tmp_8 = false;
      }
      if (tmp_8) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        // Inline function 'kotlin.text.lowercase' call
        // Inline function 'kotlin.js.asDynamic' call
        if (element.w4i_1.b4j_1.toLowerCase() === 'sms') {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    if (tmp$ret$0) {
      get_dialogPageNavigator($this_emailLogin).fbw(GenericDialog().dgh('Unable to login', 'We are unable to log you in at this time. Try contacting support if this issue persists'));
    } else {
      var tmp_9 = this$0.gev_1.iah(proof, $completion);
      if (tmp_9 === get_COROUTINE_SUSPENDED())
        tmp_9 = yield tmp_9;
      var tmp0_0 = session.j4k_1;
      var tmp$ret$7;
      $l$block_1: {
        // Inline function 'kotlin.collections.first' call
        var _iterator__ex2g4s_0 = tmp0_0.m1();
        while (_iterator__ex2g4s_0.n1()) {
          var element_0 = _iterator__ex2g4s_0.o1();
          // Inline function 'kotlin.text.lowercase' call
          // Inline function 'kotlin.js.asDynamic' call
          if (element_0.w4i_1.b4j_1.toLowerCase() === 'sms') {
            tmp$ret$7 = element_0;
            break $l$block_1;
          }
        }
        throw NoSuchElementException().o('Collection contains no element matching the predicate.');
      }
      var option = tmp$ret$7;
      var tmp_10 = this$0.hev_1.iah(option, $completion);
      if (tmp_10 === get_COROUTINE_SUSPENDED())
        tmp_10 = yield tmp_10;
      var tmp_11 = api.yfg_1.pei(ensureNotNull(option.x4i_1), $completion);
      if (tmp_11 === get_COROUTINE_SUSPENDED())
        tmp_11 = yield tmp_11;
      this$0.iev_1.oam(tmp_11);
    }
  }
  return Unit_instance;
}
function emailLogin$confirmPasscode(secret, passcode, this$0, $this_emailLogin, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_emailLogin$confirmPasscode__54fdz3.bind(VOID, secret, passcode, this$0, $this_emailLogin), $completion);
}
function emailLogin$_anonymous_$_anonymous_$_anonymous_$a_xv5gcl(document, text) {
  var tmp0_safe_receiver = get_AutoRoutes().pbw(new (ViewLegalDocument())(document));
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.qbw_1;
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.ubw();
  return '<a href="' + (tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs) + '">' + text + '<\/a>';
}
function *_generator_phoneLogin$confirmPasscode__xvj3kj(this$0, passcode, $this_phoneLogin, $completion) {
  var tmp = await_0(get_selectedApi(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var api = tmp.dfx();
  var tmp_0 = awaitOnce(this$0.iev_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp0_elvis_lhs = tmp_0;
  var tmp_1;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_1 = tmp0_elvis_lhs;
  }
  var tmp_2 = tmp_1;
  var tmp_3 = awaitOnce(passcode, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var tmp_4 = api.yfg_1.qei(new (FinishProof())(tmp_2, tmp_3), $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  var proof = tmp_4;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = this$0.gev_1;
  var tmp_5 = await_0(this_0, $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  var tmp$ret$0 = tmp_5;
  var tmp_6 = api.dfh_1.uei(listOf_0([proof, ensureNotNull(tmp$ret$0)]), $completion);
  if (tmp_6 === get_COROUTINE_SUSPENDED())
    tmp_6 = yield tmp_6;
  var session = tmp_6;
  if (!(session.l4k_1 == null)) {
    var tmp_7 = get_sessionToken().iah(ensureNotNull(session.l4k_1), $completion);
    if (tmp_7 === get_COROUTINE_SUSPENDED())
      tmp_7 = yield tmp_7;
    var tmp_8 = this$0.wiq($this_phoneLogin, $completion);
    if (tmp_8 === get_COROUTINE_SUSPENDED())
      tmp_8 = yield tmp_8;
  } else {
    var tmp_9 = get_dialogPageNavigator($this_phoneLogin);
    tmp_9.fbw(GenericDialog().dgh('Unable to login', 'We are unable to log you in at this time. Try contacting support if this issue persists', VOID, LogInScreen$phoneLogin$confirmPasscode$slambda_0(this$0)));
  }
  return Unit_instance;
}
function phoneLogin$confirmPasscode(this$0, passcode, $this_phoneLogin, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_phoneLogin$confirmPasscode__xvj3kj.bind(VOID, this$0, passcode, $this_phoneLogin), $completion);
}
function LogInScreen$registerForm$lambda($this$Draft) {
  var tmp0_safe_receiver = $this$Draft.daj(get_selectedContractor());
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_0 = $this$Draft.daj(get_rawSession());
    var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.lfv_1;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.geo(tmp0_safe_receiver);
    tmp = tmp2_safe_receiver == null ? null : $this$Draft.daj(tmp2_safe_receiver);
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    var tmp_1 = new (Address())();
    var tmp_2 = new (Address())();
    // Inline function 'kotlin.collections.setOf' call
    var tmp_3 = emptySet();
    // Inline function 'kotlin.collections.listOf' call
    var tmp$ret$3 = emptyList();
    tmp_0 = new (Contractor())(VOID, VOID, '', '', '', '', tmp_1, VOID, VOID, VOID, VOID, '', '', '', '', tmp_2, tmp_3, VOID, VOID, VOID, VOID, '', '', tmp$ret$3);
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  return tmp_0;
}
var LogInScreen$registerForm$slambdaClass;
function LogInScreen$registerForm$slambda() {
  if (LogInScreen$registerForm$slambdaClass === VOID) {
    class $ {
      constructor($isLegalName, $contractor, $registerSecret, $this_registerForm) {
        this.oip_1 = $isLegalName;
        this.pip_1 = $contractor;
        this.qip_1 = $registerSecret;
        this.rip_1 = $this_registerForm;
      }
      yah($this$Action, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$Action), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    LogInScreen$registerForm$slambdaClass = $;
  }
  return LogInScreen$registerForm$slambdaClass;
}
function LogInScreen$registerForm$slambda_0($isLegalName, $contractor, $registerSecret, $this_registerForm) {
  var i = new (LogInScreen$registerForm$slambda())($isLegalName, $contractor, $registerSecret, $this_registerForm);
  var l = ($this$Action, $completion) => i.yah($this$Action, $completion);
  l.$arity = 1;
  return l;
}
function LogInScreen$registerForm$lambda$lambda(it) {
  // Inline function 'kotlin.text.matches' call
  return SharedUtils_getInstance().g9s_1.rh(it);
}
function LogInScreen$registerForm$lambda$lambda_0(it) {
  // Inline function 'kotlin.text.matches' call
  return SharedUtils_getInstance().h9s_1.rh(it);
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
var LogInScreen$registerForm$slambdaClass_0;
function LogInScreen$registerForm$slambda_1() {
  if (LogInScreen$registerForm$slambdaClass_0 === VOID) {
    class $ {
      constructor($registering) {
        this.tip_1 = $registering;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    LogInScreen$registerForm$slambdaClass_0 = $;
  }
  return LogInScreen$registerForm$slambdaClass_0;
}
function LogInScreen$registerForm$slambda_2($registering) {
  var i = new (LogInScreen$registerForm$slambda_1())($registering);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var LogInScreen$registerForm$slambdaClass_1;
function LogInScreen$registerForm$slambda_3() {
  if (LogInScreen$registerForm$slambdaClass_1 === VOID) {
    class $ {
      constructor($contractor) {
        this.uip_1 = $contractor;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    LogInScreen$registerForm$slambdaClass_1 = $;
  }
  return LogInScreen$registerForm$slambdaClass_1;
}
function LogInScreen$registerForm$slambda_4($contractor) {
  var i = new (LogInScreen$registerForm$slambda_3())($contractor);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var LogInScreen$registerForm$slambdaClass_2;
function LogInScreen$registerForm$slambda_5() {
  if (LogInScreen$registerForm$slambdaClass_2 === VOID) {
    class $ {
      constructor($registerSecret) {
        this.vip_1 = $registerSecret;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    LogInScreen$registerForm$slambdaClass_2 = $;
  }
  return LogInScreen$registerForm$slambdaClass_2;
}
function LogInScreen$registerForm$slambda_6($registerSecret) {
  var i = new (LogInScreen$registerForm$slambda_5())($registerSecret);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var LogInScreen$registerForm$slambdaClass_3;
function LogInScreen$registerForm$slambda_7() {
  if (LogInScreen$registerForm$slambdaClass_3 === VOID) {
    class $ {
      constructor($contractor, $$this$col) {
        this.wip_1 = $contractor;
        this.xip_1 = $$this$col;
      }
      xiq(proof, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this, proof), $completion);
      }
      s2(p1, $completion) {
        return this.xiq(p1 instanceof Proof() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    LogInScreen$registerForm$slambdaClass_3 = $;
  }
  return LogInScreen$registerForm$slambdaClass_3;
}
function LogInScreen$registerForm$slambda_8($contractor, $$this$col) {
  var i = new (LogInScreen$registerForm$slambda_7())($contractor, $$this$col);
  var l = (proof, $completion) => i.xiq(proof, $completion);
  l.$arity = 1;
  return l;
}
var LogInScreen$emailLogin$slambdaClass;
function LogInScreen$emailLogin$slambda() {
  if (LogInScreen$emailLogin$slambdaClass === VOID) {
    class $ {
      constructor($secret, $email) {
        this.yip_1 = $secret;
        this.zip_1 = $email;
      }
      yah($this$Action, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this, $this$Action), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    LogInScreen$emailLogin$slambdaClass = $;
  }
  return LogInScreen$emailLogin$slambdaClass;
}
function LogInScreen$emailLogin$slambda_0($secret, $email) {
  var i = new (LogInScreen$emailLogin$slambda())($secret, $email);
  var l = ($this$Action, $completion) => i.yah($this$Action, $completion);
  l.$arity = 1;
  return l;
}
function LogInScreen$emailLogin$lambda($this$mutableRemember) {
  return !$this$mutableRemember.gaj(get_selectedApi()).equals(getDefaultServerBackend());
}
function LogInScreen$emailLogin$lambda_0($apiOption) {
  return (it) => it.equals($apiOption);
}
function LogInScreen$emailLogin$lambda_1($apiOption) {
  return (it) => $apiOption;
}
function Button$_get_enabled_$ref_61t7nx_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
var LogInScreen$emailLogin$slambdaClass_0;
function LogInScreen$emailLogin$slambda_1() {
  if (LogInScreen$emailLogin$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.aiq_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    LogInScreen$emailLogin$slambdaClass_0 = $;
  }
  return LogInScreen$emailLogin$slambdaClass_0;
}
function LogInScreen$emailLogin$slambda_2(this$0) {
  var i = new (LogInScreen$emailLogin$slambda_1())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
var LogInScreen$emailLogin$lambda$slambdaClass;
function LogInScreen$emailLogin$lambda$slambda() {
  if (LogInScreen$emailLogin$lambda$slambdaClass === VOID) {
    class $ {
      constructor($secret, $passcode, this$0, $this_emailLogin) {
        this.biq_1 = $secret;
        this.ciq_1 = $passcode;
        this.diq_1 = this$0;
        this.eiq_1 = $this_emailLogin;
      }
      yah($this$Action, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this, $this$Action), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    LogInScreen$emailLogin$lambda$slambdaClass = $;
  }
  return LogInScreen$emailLogin$lambda$slambdaClass;
}
function LogInScreen$emailLogin$lambda$slambda_0($secret, $passcode, this$0, $this_emailLogin) {
  var i = new (LogInScreen$emailLogin$lambda$slambda())($secret, $passcode, this$0, $this_emailLogin);
  var l = ($this$Action, $completion) => i.yah($this$Action, $completion);
  l.$arity = 1;
  return l;
}
function Button$_get_enabled_$ref_61t7nx_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
var LogInScreen$emailLogin$confirmPasscode$refClass;
function LogInScreen$emailLogin$confirmPasscode$ref() {
  if (LogInScreen$emailLogin$confirmPasscode$refClass === VOID) {
    class $ {
      constructor($secret, $passcode, this$0, $this_emailLogin) {
        this.yiq_1 = $secret;
        this.ziq_1 = $passcode;
        this.air_1 = this$0;
        this.bir_1 = $this_emailLogin;
      }
      uao($completion) {
        return emailLogin$confirmPasscode(this.yiq_1, this.ziq_1, this.air_1, this.bir_1, $completion);
      }
    }
    initMetadataForFunctionReference($, VOID, VOID, [0]);
    LogInScreen$emailLogin$confirmPasscode$refClass = $;
  }
  return LogInScreen$emailLogin$confirmPasscode$refClass;
}
function LogInScreen$emailLogin$confirmPasscode$ref_0($secret, $passcode, this$0, $this_emailLogin) {
  var i = new (LogInScreen$emailLogin$confirmPasscode$ref())($secret, $passcode, this$0, $this_emailLogin);
  var l = ($completion) => i.uao($completion);
  l.callableName = 'confirmPasscode';
  l.$arity = 0;
  return l;
}
var LogInScreen$emailLogin$slambdaClass_1;
function LogInScreen$emailLogin$slambda_3() {
  if (LogInScreen$emailLogin$slambdaClass_1 === VOID) {
    class $ {
      constructor($secret, $email, $passcode, $showIcon) {
        this.giq_1 = $secret;
        this.hiq_1 = $email;
        this.iiq_1 = $passcode;
        this.jiq_1 = $showIcon;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    LogInScreen$emailLogin$slambdaClass_1 = $;
  }
  return LogInScreen$emailLogin$slambdaClass_1;
}
function LogInScreen$emailLogin$slambda_4($secret, $email, $passcode, $showIcon) {
  var i = new (LogInScreen$emailLogin$slambda_3())($secret, $email, $passcode, $showIcon);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var LogInScreen$emailLogin$slambdaClass_2;
function LogInScreen$emailLogin$slambda_5() {
  if (LogInScreen$emailLogin$slambdaClass_2 === VOID) {
    class $ {
      constructor($secret, $passcode) {
        this.kiq_1 = $secret;
        this.liq_1 = $passcode;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_9.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    LogInScreen$emailLogin$slambdaClass_2 = $;
  }
  return LogInScreen$emailLogin$slambdaClass_2;
}
function LogInScreen$emailLogin$slambda_6($secret, $passcode) {
  var i = new (LogInScreen$emailLogin$slambda_5())($secret, $passcode);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
var LogInScreen$phoneLogin$lambda$slambdaClass;
function LogInScreen$phoneLogin$lambda$slambda() {
  if (LogInScreen$phoneLogin$lambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $passcode, $this_phoneLogin) {
        this.miq_1 = this$0;
        this.niq_1 = $passcode;
        this.oiq_1 = $this_phoneLogin;
      }
      yah($this$Action, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_10.bind(VOID, this, $this$Action), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    LogInScreen$phoneLogin$lambda$slambdaClass = $;
  }
  return LogInScreen$phoneLogin$lambda$slambdaClass;
}
function LogInScreen$phoneLogin$lambda$slambda_0(this$0, $passcode, $this_phoneLogin) {
  var i = new (LogInScreen$phoneLogin$lambda$slambda())(this$0, $passcode, $this_phoneLogin);
  var l = ($this$Action, $completion) => i.yah($this$Action, $completion);
  l.$arity = 1;
  return l;
}
function Button$_get_enabled_$ref_61t7nx_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
var LogInScreen$phoneLogin$confirmPasscode$refClass;
function LogInScreen$phoneLogin$confirmPasscode$ref() {
  if (LogInScreen$phoneLogin$confirmPasscode$refClass === VOID) {
    class $ {
      constructor(this$0, $passcode, $this_phoneLogin) {
        this.cir_1 = this$0;
        this.dir_1 = $passcode;
        this.eir_1 = $this_phoneLogin;
      }
      uao($completion) {
        return phoneLogin$confirmPasscode(this.cir_1, this.dir_1, this.eir_1, $completion);
      }
    }
    initMetadataForFunctionReference($, VOID, VOID, [0]);
    LogInScreen$phoneLogin$confirmPasscode$refClass = $;
  }
  return LogInScreen$phoneLogin$confirmPasscode$refClass;
}
function LogInScreen$phoneLogin$confirmPasscode$ref_0(this$0, $passcode, $this_phoneLogin) {
  var i = new (LogInScreen$phoneLogin$confirmPasscode$ref())(this$0, $passcode, $this_phoneLogin);
  var l = ($completion) => i.uao($completion);
  l.callableName = 'confirmPasscode';
  l.$arity = 0;
  return l;
}
var LogInScreen$phoneLogin$slambdaClass;
function LogInScreen$phoneLogin$slambda() {
  if (LogInScreen$phoneLogin$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $passcode, $showIcon) {
        this.qiq_1 = this$0;
        this.riq_1 = $passcode;
        this.siq_1 = $showIcon;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_12.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    LogInScreen$phoneLogin$slambdaClass = $;
  }
  return LogInScreen$phoneLogin$slambdaClass;
}
function LogInScreen$phoneLogin$slambda_0(this$0, $passcode, $showIcon) {
  var i = new (LogInScreen$phoneLogin$slambda())(this$0, $passcode, $showIcon);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var LogInScreen$render$slambdaClass;
function LogInScreen$render$slambda() {
  if (LogInScreen$render$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $$this$frame) {
        this.tiq_1 = this$0;
        this.uiq_1 = $$this$frame;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_13.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    LogInScreen$render$slambdaClass = $;
  }
  return LogInScreen$render$slambdaClass;
}
function LogInScreen$render$slambda_0(this$0, $$this$frame) {
  var i = new (LogInScreen$render$slambda())(this$0, $$this$frame);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var LogInScreen$phoneLogin$confirmPasscode$slambdaClass;
function LogInScreen$phoneLogin$confirmPasscode$slambda() {
  if (LogInScreen$phoneLogin$confirmPasscode$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.viq_1 = this$0;
      }
      ygg($this$GenericDialog, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_14.bind(VOID, this, $this$GenericDialog), $completion);
      }
      s2(p1, $completion) {
        return this.ygg(p1 instanceof ViewWriter() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    LogInScreen$phoneLogin$confirmPasscode$slambdaClass = $;
  }
  return LogInScreen$phoneLogin$confirmPasscode$slambdaClass;
}
function LogInScreen$phoneLogin$confirmPasscode$slambda_0(this$0) {
  var i = new (LogInScreen$phoneLogin$confirmPasscode$slambda())(this$0);
  var l = ($this$GenericDialog, $completion) => i.ygg($this$GenericDialog, $completion);
  l.$arity = 1;
  return l;
}
var LogInScreenClass;
function LogInScreen() {
  if (LogInScreenClass === VOID) {
    class $ {
      constructor() {
        this.eev_1 = Signal().hak(null);
        this.fev_1 = null;
        this.gev_1 = Signal().hak(null);
        this.hev_1 = Signal().hak(null);
        this.iev_1 = Signal().hak(null);
        this.jev_1 = Signal().hak(false);
      }
      fir(value) {
        this.fev_1 = value;
        var tmp;
        if (value == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          var tmp0_safe_receiver = get_AutoRoutes().pbw(value);
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.qbw_1;
          tmp = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.ubw();
        }
        this.eev_1.oam(tmp);
      }
      gir(_this__u8e3s4, registering) {
        var registerSecret = Signal().hak(null);
        var contractor = validated(Draft(LogInScreen$registerForm$lambda));
        var isLegalName = Signal().hak(true);
        var tmp = Companion_getInstance().tcg_1;
        var submitRegistration = Action('REGISTER', tmp, VOID, VOID, VOID, VOID, LogInScreen$registerForm$slambda_0(isLegalName, contractor, registerSecret, _this__u8e3s4));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (Frame())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        var tmp_0 = shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.daj(registerSecret) == null);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.zbm(true);
        title(view_0, 'Register Account');
        boldSubTitle(view_0, 'Primary Representative');
        requiredField3(view_0, 'First Name', VOID, ($this$requiredField3) => {
          // Inline function 'com.lightningkite.serialization.lensPath' call
          var this_0 = contractor;
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp = serializerOrContextual(createKType(getKClass(Contractor()), arrayOf([]), false));
          var tmp$ret$0 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
          var it = new (DataClassPathSelf())(tmp$ret$0);
          var tmp$ret$2 = get_contactFirstName(it);
          var tmp$ret$3 = lensPath(this_0, tmp$ret$2);
          var firstName = assertNotBlank(tmp$ret$3);
          var tmp_0 = validate($this$requiredField3, firstName);
          // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextInput())($this$requiredField3.pc());
          var tmp0_elvis_lhs = $this$requiredField3.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$requiredField3 : tmp0_elvis_lhs;
          $this$requiredField3.gbb(p, view);
          // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
          // Inline function 'com.lightningkite.kiteui.views.placeholder' call
          view.vb5_1.bb4_1.kb7_1.placeholder = 'John';
          view.cbs(Companion_getInstance_0().sd5_1);
          view.zah(view.icn_1, firstName);
          view.obg(submitRegistration);
          $this$requiredField3.hbb(p, view);
          return $this$requiredField3.lbb(tmp_0, view);
        });
        requiredField3(view_0, 'Last Name', VOID, ($this$requiredField3) => {
          // Inline function 'com.lightningkite.serialization.lensPath' call
          var this_0 = contractor;
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp = serializerOrContextual(createKType(getKClass(Contractor()), arrayOf([]), false));
          var tmp$ret$9 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
          var it = new (DataClassPathSelf())(tmp$ret$9);
          var tmp$ret$11 = get_contactLastName(it);
          var tmp$ret$12 = lensPath(this_0, tmp$ret$11);
          var lastName = assertNotBlank(tmp$ret$12);
          var tmp_0 = validate($this$requiredField3, lastName);
          // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextInput())($this$requiredField3.pc());
          var tmp0_elvis_lhs = $this$requiredField3.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$requiredField3 : tmp0_elvis_lhs;
          $this$requiredField3.gbb(p, view);
          // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
          // Inline function 'com.lightningkite.kiteui.views.placeholder' call
          view.vb5_1.bb4_1.kb7_1.placeholder = 'Smith';
          view.cbs(Companion_getInstance_0().sd5_1);
          view.zah(view.icn_1, lastName);
          view.obg(submitRegistration);
          $this$requiredField3.hbb(p, view);
          return $this$requiredField3.lbb(tmp_0, view);
        });
        requiredField3(view_0, 'Work Email', VOID, ($this$requiredField3) => {
          // Inline function 'com.lightningkite.serialization.lensPath' call
          var this_0 = contractor;
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp = serializerOrContextual(createKType(getKClass(Contractor()), arrayOf([]), false));
          var tmp$ret$18 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
          var it = new (DataClassPathSelf())(tmp$ret$18);
          var tmp$ret$20 = get_contactEmail(it);
          var tmp_0 = lensPath(this_0, tmp$ret$20);
          var contactEmail = assert(tmp_0, 'Must be a valid email', VOID, VOID, LogInScreen$registerForm$lambda$lambda);
          var tmp_1 = validate($this$requiredField3, contactEmail);
          // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextInput())($this$requiredField3.pc());
          var tmp0_elvis_lhs = $this$requiredField3.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$requiredField3 : tmp0_elvis_lhs;
          $this$requiredField3.gbb(p, view);
          // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
          var value = 'john@company.com';
          // Inline function 'com.lightningkite.kiteui.views.placeholder' call
          view.vb5_1.bb4_1.kb7_1.placeholder = value;
          view.cbs(Companion_getInstance_0().zd5_1);
          view.zah(view.icn_1, contactEmail);
          view.obg(submitRegistration);
          $this$requiredField3.hbb(p, view);
          return $this$requiredField3.lbb(tmp_1, view);
        });
        requiredField3(view_0, 'Cell Phone', 'Must be a cellphone for authentication', ($this$requiredField3) => {
          // Inline function 'com.lightningkite.serialization.lensPath' call
          var this_0 = contractor;
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp = serializerOrContextual(createKType(getKClass(Contractor()), arrayOf([]), false));
          var tmp$ret$27 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
          var it = new (DataClassPathSelf())(tmp$ret$27);
          var tmp$ret$29 = get_contactPhoneNumber(it);
          var tmp_0 = lensPath(this_0, tmp$ret$29);
          var contactPhone = assert(tmp_0, 'Must be a valid phone number', VOID, VOID, LogInScreen$registerForm$lambda$lambda_0);
          var tmp_1 = validate($this$requiredField3, contactPhone);
          // Inline function 'com.lightningkite.kiteui.views.direct.phoneNumberInput' call
          // Inline function 'kotlin.apply' call
          var this_1 = new (PhoneNumberInput())($this$requiredField3);
          this_1.vcl('(123) 456-7890');
          $this$requiredField3.zah(this_1.c2a(), contactPhone);
          return $this$requiredField3.lbb(tmp_1, this_1);
        });
        greySeparator(view_0);
        boldSubTitle(view_0, 'Business Name(s)');
        requiredField3(view_0, 'Trade Name or DBA', 'This is the business name your clients know you by. This will be your Stoze account name.', ($this$requiredField3) => {
          // Inline function 'com.lightningkite.serialization.lensPath' call
          var this_0 = contractor;
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp = serializerOrContextual(createKType(getKClass(Contractor()), arrayOf([]), false));
          var tmp$ret$34 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
          var it = new (DataClassPathSelf())(tmp$ret$34);
          var tmp$ret$36 = get_name(it);
          var tmp$ret$37 = lensPath(this_0, tmp$ret$36);
          var contractorName = assertNotBlank(tmp$ret$37);
          var tmp_0 = validate($this$requiredField3, contractorName);
          // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextInput())($this$requiredField3.pc());
          var tmp0_elvis_lhs = $this$requiredField3.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$requiredField3 : tmp0_elvis_lhs;
          $this$requiredField3.gbb(p, view);
          // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
          var value = 'Enter Company Name';
          // Inline function 'com.lightningkite.kiteui.views.placeholder' call
          view.vb5_1.bb4_1.kb7_1.placeholder = value;
          view.cbs(Companion_getInstance_0().sd5_1);
          view.zah(view.icn_1, contractorName);
          view.obg(submitRegistration);
          $this$requiredField3.hbb(p, view);
          return $this$requiredField3.lbb(tmp_0, view);
        });
        label2(view_0, 'Is this also the registered legal name?', VOID, ($this$label2) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$label2.pc());
          var tmp0_elvis_lhs = $this$label2.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
          $this$label2.gbb(p, view);
          view.zbm(false);
          var tmp = get_centered(view);
          // Inline function 'com.lightningkite.kiteui.views.direct.radioButton' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (RadioButton())(view.pc());
          var tmp0_elvis_lhs_0 = view.ebb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.gbb(p_0, view_0);
          view_0.zah(view_0.pc7_1, isLegalName);
          view.hbb(p_0, view_0);
          view.lbb(tmp, view_0);
          view.lbb(get_centered(view), body(view, 'Yes'));
          var tmp_0 = get_centered(view);
          // Inline function 'com.lightningkite.kiteui.views.direct.radioButton' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (RadioButton())(view.pc());
          var tmp0_elvis_lhs_1 = view.ebb_1;
          var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
          view.gbb(p_1, view_1);
          view_1.zah(view_1.pc7_1, equalTo(isLegalName, false));
          view.hbb(p_1, view_1);
          view.lbb(tmp_0, view_1);
          view.lbb(get_centered(view), body(view, 'No'));
          $this$label2.hbb(p, view);
          return view;
        });
        var tmp_1 = shownWhen(view_0, VOID, ($this$shownWhen) => !$this$shownWhen.daj(isLegalName));
        view_0.lbb(tmp_1, requiredField3(view_0, 'Business Legal Name', VOID, ($this$requiredField3) => {
          // Inline function 'com.lightningkite.serialization.lensPath' call
          var this_0 = contractor;
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp = serializerOrContextual(createKType(getKClass(Contractor()), arrayOf([]), false));
          var tmp$ret$53 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
          var it = new (DataClassPathSelf())(tmp$ret$53);
          var tmp$ret$55 = get_legalName(it);
          var tmp$ret$56 = lensPath(this_0, tmp$ret$55);
          var legalContractorName = assertNotBlank(tmp$ret$56);
          var tmp_0 = validate($this$requiredField3, legalContractorName);
          // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextInput())($this$requiredField3.pc());
          var tmp0_elvis_lhs = $this$requiredField3.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$requiredField3 : tmp0_elvis_lhs;
          $this$requiredField3.gbb(p, view);
          // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
          var value = 'Enter Legal Name';
          // Inline function 'com.lightningkite.kiteui.views.placeholder' call
          view.vb5_1.bb4_1.kb7_1.placeholder = value;
          view.cbs(Companion_getInstance_0().sd5_1);
          view.zah(view.icn_1, legalContractorName);
          view.obg(submitRegistration);
          $this$requiredField3.hbb(p, view);
          return $this$requiredField3.lbb(tmp_0, view);
        }));
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (Space())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.gbb(p_1, view_1);
        view_0.hbb(p_1, view_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_2 = view_0.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
        view_0.gbb(p_2, view_2);
        view_2.zbm(true);
        var tmp_2 = get_primaryButton(view_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (Button())(view_2.pc());
        var tmp0_elvis_lhs_3 = view_2.ebb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
        view_2.gbb(p_3, view_3);
        var tmp_3 = KMutableProperty0();
        var tmp_4 = Button$_get_enabled_$ref_61t7nx(view_3);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_0 = getPropertyCallableRef('enabled', 0, tmp_3, tmp_4, Button$_set_enabled_$ref_o8kynz(view_3));
        reactiveScope(view_3, ($this$reactiveScope) => {
          var draft = $this$reactiveScope.daj(contractor);
          var tmp;
          var tmp_0;
          var tmp_1;
          var tmp_2;
          var tmp_3;
          // Inline function 'kotlin.text.isNotBlank' call
          var this_1 = draft.e5j_1;
          if (!isBlank(this_1)) {
            // Inline function 'kotlin.text.isNotBlank' call
            var this_2 = draft.f5j_1;
            tmp_3 = !isBlank(this_2);
          } else {
            tmp_3 = false;
          }
          if (tmp_3) {
            var tmp0 = draft.g5j_1;
            // Inline function 'kotlin.text.matches' call
            tmp_2 = SharedUtils_getInstance().g9s_1.rh(tmp0);
          } else {
            tmp_2 = false;
          }
          if (tmp_2) {
            var tmp0_0 = draft.h5j_1;
            // Inline function 'kotlin.text.matches' call
            tmp_1 = SharedUtils_getInstance().h9s_1.rh(tmp0_0);
          } else {
            tmp_1 = false;
          }
          if (tmp_1) {
            // Inline function 'kotlin.text.isNotBlank' call
            var this_3 = draft.v5i_1;
            tmp_0 = !isBlank(this_3);
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            var tmp_4;
            if ($this$reactiveScope.daj(isLegalName)) {
              tmp_4 = true;
            } else {
              // Inline function 'kotlin.text.isNotBlank' call
              var this_4 = draft.w5i_1;
              tmp_4 = !isBlank(this_4);
            }
            tmp = tmp_4;
          } else {
            tmp = false;
          }
          var tmp$ret$71 = tmp;
          this_0.set(tmp$ret$71);
          return Unit_instance;
        });
        // Inline function 'com.crowpay.views.theming.body' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (TextView())(view_3.pc());
        var tmp0_elvis_lhs_4 = view_3.ebb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
        view_3.gbb(p_4, view_4);
        view_4.lba(view_4.qb6_1.abf(BodySemantic_getInstance()));
        view_4.dbs(Align_Center_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var value = 'Register';
        var tmp_5 = view_4.vb5_1;
        var tmp_6;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(value) === 0) {
          tmp_6 = '\xA0';
        } else {
          tmp_6 = value;
        }
        tmp_5.hbu(tmp_6);
        view_3.hbb(p_4, view_4);
        view_3.obg(submitRegistration);
        view_2.hbb(p_3, view_3);
        view_2.lbb(tmp_2, view_3);
        errorText(view_2);
        view_0.hbb(p_2, view_2);
        var tmp_7 = get_centered(view_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_5 = view_0.ebb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_0 : tmp0_elvis_lhs_5;
        view_0.gbb(p_5, view_5);
        view_5.zbm(false);
        view_5.bb9(get_rem(0.5));
        body(view_5, 'Already have an account? ');
        var tmp_8 = colored(view_5, AppColors_getInstance().ffz_1.zg9_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (Button())(view_5.pc());
        var tmp0_elvis_lhs_6 = view_5.ebb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
        view_5.gbb(p_6, view_6);
        view_6.gba(get_dp(1));
        view_6.bb9(get_dp(1));
        body(view_6, 'Sign in');
        onClick(view_6, VOID, VOID, LogInScreen$registerForm$slambda_2(registering));
        view_5.hbb(p_6, view_6);
        view_5.lbb(tmp_8, view_6);
        view_0.hbb(p_5, view_5);
        view_0.lbb(tmp_7, view_5);
        view.hbb(p_0, view_0);
        view.lbb(tmp_0, view_0);
        var tmp_9 = shownWhen(view, VOID, ($this$shownWhen) => !($this$shownWhen.daj(registerSecret) == null));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_7 = view.ebb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view : tmp0_elvis_lhs_7;
        view.gbb(p_7, view_7);
        view_7.zbm(true);
        var tmp_10 = notNull(registerSecret, '');
        var tmp_11 = LogInScreen$registerForm$slambda_4(contractor);
        var tmp_12 = ($this$EmailProof) => $this$EmailProof.daj(contractor).g5j_1;
        var tmp_13 = LogInScreen$registerForm$slambda_6(registerSecret);
        render(EmailProof().mip(tmp_10, tmp_11, tmp_12, tmp_13, LogInScreen$registerForm$slambda_8(contractor, view_7)), view_7);
        view.hbb(p_7, view_7);
        view.lbb(tmp_9, view_7);
        _this__u8e3s4.hbb(p, view);
        return view;
      }
      wiq(_this__u8e3s4, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_finishLogin__x2wmg2.bind(VOID, this, _this__u8e3s4), $completion);
      }
      hir(_this__u8e3s4) {
        var email = Signal().hak('');
        var secret = Signal().hak(null);
        var passcode = Signal().hak('');
        var tmp = Companion_getInstance().ecg_1;
        var sendEmail = Action('LOG IN', tmp, VOID, VOID, VOID, VOID, LogInScreen$emailLogin$slambda_0(secret, email));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.zbm(true);
        var tmp_0 = shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.daj(secret) == null);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.zbm(true);
        var devSettingsEnabled = mutableRemember(VOID, VOID, LogInScreen$emailLogin$lambda);
        reactive(view_0, ($this$reactive) => {
          var p = $this$reactive.daj(email);
          var tmp;
          if (p === '84321') {
            println('Turning on Dev Settings');
            set_value(devSettingsEnabled, true);
            tmp = Unit_instance;
          }
          return Unit_instance;
        });
        title(view_0, 'Log In');
        label2(view_0, 'Email', VOID, ($this$label2) => {
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var tmp = $this$label2.jbb(FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextInput())($this$label2.pc());
          var tmp0_elvis_lhs = $this$label2.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
          $this$label2.gbb(p, view);
          // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
          // Inline function 'com.lightningkite.kiteui.views.placeholder' call
          view.vb5_1.bb4_1.kb7_1.placeholder = 'Email';
          view.cbs(Companion_getInstance_0().zd5_1);
          view.zah(view.icn_1, email);
          view.obg(sendEmail);
          $this$label2.hbb(p, view);
          return $this$label2.lbb(tmp, view);
        });
        var tmp_1 = shownWhen(view_0, VOID, ($this$shownWhen) => $this$shownWhen.daj(devSettingsEnabled));
        // Inline function 'com.lightningkite.kiteui.views.card' call
        var tmp$ret$6 = view_0.jbb(CardSemantic_getInstance());
        var tmp_2 = view_0.kbb(tmp_1, tmp$ret$6);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.gbb(p_1, view_1);
        view_1.zbm(true);
        var default_0 = getDefaultServerBackend();
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = get_entries().m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_2 = new (RowOrCol())(view_1.pc());
          var tmp0_elvis_lhs_2 = view_1.ebb_1;
          var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
          view_1.gbb(p_2, view_2);
          view_2.zbm(false);
          // Inline function 'com.lightningkite.kiteui.views.direct.radioButton' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_3 = new (RadioButton())(view_2.pc());
          var tmp0_elvis_lhs_3 = view_2.ebb_1;
          var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
          view_2.gbb(p_3, view_3);
          var tmp_3 = get_selectedApi();
          var tmp_4 = LogInScreen$emailLogin$lambda_0(element);
          view_3.zah(view_3.pc7_1, tmp_3.vak(tmp_4, LogInScreen$emailLogin$lambda_1(element)));
          view_2.hbb(p_3, view_3);
          // Inline function 'com.crowpay.views.theming.body' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_4 = new (TextView())(view_2.pc());
          var tmp0_elvis_lhs_4 = view_2.ebb_1;
          var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
          view_2.gbb(p_4, view_4);
          view_4.lba(view_4.qb6_1.abf(BodySemantic_getInstance()));
          // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
          var value = element.equals(default_0) ? element.a4_1 + ' (Default)' : element.a4_1;
          var tmp_5 = view_4.vb5_1;
          var tmp_6;
          // Inline function 'kotlin.text.isEmpty' call
          if (charSequenceLength(value) === 0) {
            tmp_6 = '\xA0';
          } else {
            tmp_6 = value;
          }
          tmp_5.hbu(tmp_6);
          view_2.hbb(p_4, view_4);
          view_1.hbb(p_2, view_2);
        }
        view_0.hbb(p_1, view_1);
        view_0.lbb(tmp_2, view_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (Space())(view_0.pc());
        var tmp0_elvis_lhs_5 = view_0.ebb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_0 : tmp0_elvis_lhs_5;
        view_0.gbb(p_5, view_5);
        view_0.hbb(p_5, view_5);
        var tmp_7 = get_primaryButton(view_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (Button())(view_0.pc());
        var tmp0_elvis_lhs_6 = view_0.ebb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_0 : tmp0_elvis_lhs_6;
        view_0.gbb(p_6, view_6);
        var tmp_8 = KMutableProperty0();
        var tmp_9 = Button$_get_enabled_$ref_61t7nx_0(view_6);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_0 = getPropertyCallableRef('enabled', 0, tmp_8, tmp_9, Button$_set_enabled_$ref_o8kynz_0(view_6));
        reactiveScope(view_6, ($this$reactiveScope) => {
          var tmp0 = $this$reactiveScope.daj(email);
          // Inline function 'kotlin.text.matches' call
          var tmp$ret$31 = SharedUtils_getInstance().g9s_1.rh(tmp0);
          this_0.set(tmp$ret$31);
          return Unit_instance;
        });
        // Inline function 'com.crowpay.views.theming.body' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (TextView())(view_6.pc());
        var tmp0_elvis_lhs_7 = view_6.ebb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view_6 : tmp0_elvis_lhs_7;
        view_6.gbb(p_7, view_7);
        view_7.lba(view_7.qb6_1.abf(BodySemantic_getInstance()));
        view_7.dbs(Align_Center_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var tmp_10 = view_7.vb5_1;
        var tmp_11;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength('Log In') === 0) {
          tmp_11 = '\xA0';
        } else {
          tmp_11 = 'Log In';
        }
        tmp_10.hbu(tmp_11);
        view_6.hbb(p_7, view_7);
        view_6.obg(sendEmail);
        view_0.hbb(p_6, view_6);
        view_0.lbb(tmp_7, view_6);
        var tmp_12 = get_centered(view_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_8 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_8 = view_0.ebb_1;
        var p_8 = tmp0_elvis_lhs_8 == null ? view_0 : tmp0_elvis_lhs_8;
        view_0.gbb(p_8, view_8);
        view_8.zbm(false);
        view_8.bb9(get_rem(0.5));
        body(view_8, 'Are you a contractor? ');
        var tmp_13 = colored(view_8, AppColors_getInstance().ffz_1.zg9_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_9 = new (Button())(view_8.pc());
        var tmp0_elvis_lhs_9 = view_8.ebb_1;
        var p_9 = tmp0_elvis_lhs_9 == null ? view_8 : tmp0_elvis_lhs_9;
        view_8.gbb(p_9, view_9);
        view_9.gba(get_dp(1));
        view_9.bb9(get_dp(1));
        body(view_9, 'Sign Up');
        onClick(view_9, VOID, VOID, LogInScreen$emailLogin$slambda_2(this));
        view_8.hbb(p_9, view_9);
        view_8.lbb(tmp_13, view_9);
        view_0.hbb(p_8, view_8);
        view_0.lbb(tmp_12, view_8);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_10 = new (Space())(view_0.pc(), 0.1);
        var tmp0_elvis_lhs_10 = view_0.ebb_1;
        var p_10 = tmp0_elvis_lhs_10 == null ? view_0 : tmp0_elvis_lhs_10;
        view_0.gbb(p_10, view_10);
        view_0.hbb(p_10, view_10);
        var tmp_14 = get_centered(view_0);
        // Inline function 'com.crowpay.views.theming.smallBody' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_11 = new (TextView())(view_0.pc());
        var tmp0_elvis_lhs_11 = view_0.ebb_1;
        var p_11 = tmp0_elvis_lhs_11 == null ? view_0 : tmp0_elvis_lhs_11;
        view_0.gbb(p_11, view_11);
        view_11.lba(view_11.qb6_1.abf(SmallBodySemantic_getInstance()));
        view_11.ccp('By continuing you agree to our ' + emailLogin$_anonymous_$_anonymous_$_anonymous_$a_xv5gcl(Type_ContractorTermsAndConditions_getInstance(), 'terms and conditions') + ' and ' + emailLogin$_anonymous_$_anonymous_$_anonymous_$a_xv5gcl(Type_PrivacyPolicy_getInstance(), 'privacy policy') + '.');
        view_0.hbb(p_11, view_11);
        view_0.lbb(tmp_14, view_11);
        view.hbb(p_0, view_0);
        view.lbb(tmp_0, view_0);
        var tmp_15 = shownWhen(view, VOID, ($this$shownWhen) => !($this$shownWhen.daj(secret) == null));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_12 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_12 = view.ebb_1;
        var p_12 = tmp0_elvis_lhs_12 == null ? view : tmp0_elvis_lhs_12;
        view.gbb(p_12, view_12);
        view_12.zbm(true);
        title(view_12, 'Log In');
        // Inline function 'com.crowpay.views.theming.body' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_13 = new (TextView())(view_12.pc());
        var tmp0_elvis_lhs_13 = view_12.ebb_1;
        var p_13 = tmp0_elvis_lhs_13 == null ? view_12 : tmp0_elvis_lhs_13;
        view_12.gbb(p_13, view_13);
        view_13.lba(view_13.qb6_1.abf(BodySemantic_getInstance()));
        var tmp_16 = KMutableProperty0();
        var tmp_17 = TextView$_get_content_$ref_4pzcwl(view_13);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_1 = getPropertyCallableRef('content', 0, tmp_16, tmp_17, TextView$_set_content_$ref_pketfb(view_13));
        reactiveScope(view_13, ($this$reactiveScope) => {
          var tmp$ret$62 = 'An email with a passcode was sent to ' + $this$reactiveScope.daj(email) + '. Enter the passcode below to confirm login.';
          this_1.set(tmp$ret$62);
          return Unit_instance;
        });
        view_12.hbb(p_13, view_13);
        label2(view_12, 'Passcode', VOID, ($this$label2) => {
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var tmp = $this$label2.jbb(FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextInput())($this$label2.pc());
          var tmp0_elvis_lhs = $this$label2.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
          $this$label2.gbb(p, view);
          // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
          var value = 'Passcode';
          // Inline function 'com.lightningkite.kiteui.views.placeholder' call
          view.vb5_1.bb4_1.kb7_1.placeholder = value;
          view.cbs(Companion_getInstance_0().td5_1);
          view.zah(view.icn_1, passcode);
          var tmp_0 = Companion_getInstance().ecg_1;
          view.obg(Action('LOG IN', tmp_0, VOID, VOID, VOID, VOID, LogInScreen$emailLogin$lambda$slambda_0(secret, passcode, this, _this__u8e3s4)));
          $this$label2.hbb(p, view);
          return $this$label2.lbb(tmp, view);
        });
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_14 = new (Space())(view_12.pc());
        var tmp0_elvis_lhs_14 = view_12.ebb_1;
        var p_14 = tmp0_elvis_lhs_14 == null ? view_12 : tmp0_elvis_lhs_14;
        view_12.gbb(p_14, view_14);
        view_12.hbb(p_14, view_14);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_15 = new (RowOrCol())(view_12.pc());
        var tmp0_elvis_lhs_15 = view_12.ebb_1;
        var p_15 = tmp0_elvis_lhs_15 == null ? view_12 : tmp0_elvis_lhs_15;
        view_12.gbb(p_15, view_15);
        view_15.zbm(true);
        var tmp_18 = get_primaryButton(view_15);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_16 = new (Button())(view_15.pc());
        var tmp0_elvis_lhs_16 = view_15.ebb_1;
        var p_16 = tmp0_elvis_lhs_16 == null ? view_15 : tmp0_elvis_lhs_16;
        view_15.gbb(p_16, view_16);
        var tmp_19 = KMutableProperty0();
        var tmp_20 = Button$_get_enabled_$ref_61t7nx_1(view_16);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_2 = getPropertyCallableRef('enabled', 0, tmp_19, tmp_20, Button$_set_enabled_$ref_o8kynz_1(view_16));
        reactiveScope(view_16, ($this$reactiveScope) => {
          var tmp$ret$78 = $this$reactiveScope.daj(passcode).length === 6;
          this_2.set(tmp$ret$78);
          return Unit_instance;
        });
        // Inline function 'com.crowpay.views.theming.body' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_17 = new (TextView())(view_16.pc());
        var tmp0_elvis_lhs_17 = view_16.ebb_1;
        var p_17 = tmp0_elvis_lhs_17 == null ? view_16 : tmp0_elvis_lhs_17;
        view_16.gbb(p_17, view_17);
        view_17.lba(view_17.qb6_1.abf(BodySemantic_getInstance()));
        view_17.dbs(Align_Center_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var tmp_21 = view_17.vb5_1;
        var tmp_22;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength('Log In') === 0) {
          tmp_22 = '\xA0';
        } else {
          tmp_22 = 'Log In';
        }
        tmp_21.hbu(tmp_22);
        view_16.hbb(p_17, view_17);
        onClick(view_16, VOID, VOID, LogInScreen$emailLogin$confirmPasscode$ref_0(secret, passcode, this, _this__u8e3s4));
        view_15.hbb(p_16, view_16);
        view_15.lbb(tmp_18, view_16);
        errorText(view_15);
        view_12.hbb(p_15, view_15);
        smallBody(view_12, 'If you did not receive a code, please check the email address provided or try again.');
        var tmp_23 = view_12.kbb(get_centered(view_12), get_textButton(view_12));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_18 = new (Button())(view_12.pc());
        var tmp0_elvis_lhs_18 = view_12.ebb_1;
        var p_18 = tmp0_elvis_lhs_18 == null ? view_12 : tmp0_elvis_lhs_18;
        view_12.gbb(p_18, view_18);
        var showIcon = Signal().hak(false);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_19 = new (RowOrCol())(view_18.pc());
        var tmp0_elvis_lhs_19 = view_18.ebb_1;
        var p_19 = tmp0_elvis_lhs_19 == null ? view_18 : tmp0_elvis_lhs_19;
        view_18.gbb(p_19, view_19);
        view_19.zbm(false);
        var tmp_24 = get_centered(view_19);
        // Inline function 'com.crowpay.views.theming.smallBody' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_20 = new (TextView())(view_19.pc());
        var tmp0_elvis_lhs_20 = view_19.ebb_1;
        var p_20 = tmp0_elvis_lhs_20 == null ? view_19 : tmp0_elvis_lhs_20;
        view_19.gbb(p_20, view_20);
        view_20.lba(view_20.qb6_1.abf(SmallBodySemantic_getInstance()));
        view_20.dbs(Align_Center_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var value_0 = 'Send me a new code.';
        var tmp_25 = view_20.vb5_1;
        var tmp_26;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(value_0) === 0) {
          tmp_26 = '\xA0';
        } else {
          tmp_26 = value_0;
        }
        tmp_25.hbu(tmp_26);
        view_19.hbb(p_20, view_20);
        view_19.lbb(tmp_24, view_20);
        var tmp_27 = get_centered(view_19);
        var tmp_28 = view_19.kbb(tmp_27, shownWhen(view_19, VOID, ($this$shownWhen) => $this$shownWhen.daj(showIcon)));
        // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_21 = new (IconView())(view_19.pc());
        var tmp0_elvis_lhs_21 = view_19.ebb_1;
        var p_21 = tmp0_elvis_lhs_21 == null ? view_19 : tmp0_elvis_lhs_21;
        view_19.gbb(p_21, view_21);
        view_21.sbt(resize(Companion_getInstance().xcf_1, get_rem_0(1)));
        view_21.gbu('Done');
        view_19.hbb(p_21, view_21);
        view_19.lbb(tmp_28, view_21);
        view_18.hbb(p_19, view_19);
        onClick(view_18, VOID, VOID, LogInScreen$emailLogin$slambda_4(secret, email, passcode, showIcon));
        view_12.hbb(p_18, view_18);
        view_12.lbb(tmp_23, view_18);
        var tmp_29 = view_12.kbb(get_centered(view_12), get_textButton(view_12));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_22 = new (Button())(view_12.pc());
        var tmp0_elvis_lhs_22 = view_12.ebb_1;
        var p_22 = tmp0_elvis_lhs_22 == null ? view_12 : tmp0_elvis_lhs_22;
        view_12.gbb(p_22, view_22);
        // Inline function 'com.crowpay.views.theming.smallBody' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_23 = new (TextView())(view_22.pc());
        var tmp0_elvis_lhs_23 = view_22.ebb_1;
        var p_23 = tmp0_elvis_lhs_23 == null ? view_22 : tmp0_elvis_lhs_23;
        view_22.gbb(p_23, view_23);
        view_23.lba(view_23.qb6_1.abf(SmallBodySemantic_getInstance()));
        view_23.dbs(Align_Center_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var value_1 = 'Use a different email.';
        var tmp_30 = view_23.vb5_1;
        var tmp_31;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(value_1) === 0) {
          tmp_31 = '\xA0';
        } else {
          tmp_31 = value_1;
        }
        tmp_30.hbu(tmp_31);
        view_22.hbb(p_23, view_23);
        onClick(view_22, VOID, VOID, LogInScreen$emailLogin$slambda_6(secret, passcode));
        view_12.hbb(p_22, view_22);
        view_12.lbb(tmp_29, view_22);
        view.hbb(p_12, view_12);
        view.lbb(tmp_15, view_12);
        _this__u8e3s4.hbb(p, view);
        return view;
      }
      iir(_this__u8e3s4) {
        var passcode = Signal().hak('');
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.zbm(true);
        title(view, 'Log In');
        label2(view, 'SMS (MFA)', VOID, ($this$label2) => {
          // Inline function 'com.crowpay.views.theming.body' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextView())($this$label2.pc());
          var tmp0_elvis_lhs = $this$label2.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
          $this$label2.gbb(p, view);
          view.lba(view.qb6_1.abf(BodySemantic_getInstance()));
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl_0(view);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_0(view));
          reactiveScope(view, ($this$reactiveScope) => {
            var tmp0_safe_receiver = $this$reactiveScope.daj(this.hev_1);
            var tmp$ret$0 = 'MFA is enabled. We have sent a passcode to ' + (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.x4i_1) + '. Enter it here to continue.';
            this_0.set(tmp$ret$0);
            return Unit_instance;
          });
          $this$label2.hbb(p, view);
          return view;
        });
        label2(view, 'Passcode', VOID, ($this$label2) => {
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var tmp = $this$label2.jbb(FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextInput())($this$label2.pc());
          var tmp0_elvis_lhs = $this$label2.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
          $this$label2.gbb(p, view);
          // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
          var value = 'Passcode';
          // Inline function 'com.lightningkite.kiteui.views.placeholder' call
          view.vb5_1.bb4_1.kb7_1.placeholder = value;
          view.cbs(Companion_getInstance_0().td5_1);
          view.zah(view.icn_1, passcode);
          var tmp_0 = Companion_getInstance().ecg_1;
          view.obg(Action('LOG IN', tmp_0, VOID, VOID, VOID, VOID, LogInScreen$phoneLogin$lambda$slambda_0(this, passcode, _this__u8e3s4)));
          $this$label2.hbb(p, view);
          return $this$label2.lbb(tmp, view);
        });
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Space())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view.hbb(p_0, view_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_1 = view.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
        view.gbb(p_1, view_1);
        view_1.zbm(true);
        var tmp = get_primaryButton(view_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (Button())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.gbb(p_2, view_2);
        var tmp_0 = KMutableProperty0();
        var tmp_1 = Button$_get_enabled_$ref_61t7nx_2(view_2);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_0 = getPropertyCallableRef('enabled', 0, tmp_0, tmp_1, Button$_set_enabled_$ref_o8kynz_2(view_2));
        reactiveScope(view_2, ($this$reactiveScope) => {
          var tmp$ret$16 = $this$reactiveScope.daj(passcode).length === 6;
          this_0.set(tmp$ret$16);
          return Unit_instance;
        });
        // Inline function 'com.crowpay.views.theming.body' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (TextView())(view_2.pc());
        var tmp0_elvis_lhs_3 = view_2.ebb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
        view_2.gbb(p_3, view_3);
        view_3.lba(view_3.qb6_1.abf(BodySemantic_getInstance()));
        view_3.dbs(Align_Center_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var tmp_2 = view_3.vb5_1;
        var tmp_3;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength('Log In') === 0) {
          tmp_3 = '\xA0';
        } else {
          tmp_3 = 'Log In';
        }
        tmp_2.hbu(tmp_3);
        view_2.hbb(p_3, view_3);
        onClick(view_2, VOID, VOID, LogInScreen$phoneLogin$confirmPasscode$ref_0(this, passcode, _this__u8e3s4));
        view_1.hbb(p_2, view_2);
        view_1.lbb(tmp, view_2);
        errorText(view_1);
        view.hbb(p_1, view_1);
        var tmp_4 = view.kbb(get_centered(view), get_textButton(view));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (Button())(view.pc());
        var tmp0_elvis_lhs_4 = view.ebb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view : tmp0_elvis_lhs_4;
        view.gbb(p_4, view_4);
        var showIcon = Signal().hak(false);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (RowOrCol())(view_4.pc());
        var tmp0_elvis_lhs_5 = view_4.ebb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
        view_4.gbb(p_5, view_5);
        view_5.zbm(false);
        var tmp_5 = get_centered(view_5);
        // Inline function 'com.crowpay.views.theming.smallBody' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (TextView())(view_5.pc());
        var tmp0_elvis_lhs_6 = view_5.ebb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
        view_5.gbb(p_6, view_6);
        view_6.lba(view_6.qb6_1.abf(SmallBodySemantic_getInstance()));
        view_6.dbs(Align_Center_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var value = 'Send me a new code.';
        var tmp_6 = view_6.vb5_1;
        var tmp_7;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(value) === 0) {
          tmp_7 = '\xA0';
        } else {
          tmp_7 = value;
        }
        tmp_6.hbu(tmp_7);
        view_5.hbb(p_6, view_6);
        view_5.lbb(tmp_5, view_6);
        var tmp_8 = get_centered(view_5);
        var tmp_9 = view_5.kbb(tmp_8, shownWhen(view_5, VOID, ($this$shownWhen) => $this$shownWhen.daj(showIcon)));
        // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (IconView())(view_5.pc());
        var tmp0_elvis_lhs_7 = view_5.ebb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view_5 : tmp0_elvis_lhs_7;
        view_5.gbb(p_7, view_7);
        view_7.sbt(resize(Companion_getInstance().xcf_1, get_rem_0(1)));
        view_7.gbu('Done');
        view_5.hbb(p_7, view_7);
        view_5.lbb(tmp_9, view_7);
        view_4.hbb(p_5, view_5);
        onClick(view_4, VOID, VOID, LogInScreen$phoneLogin$slambda_0(this, passcode, showIcon));
        view.hbb(p_4, view_4);
        view.lbb(tmp_4, view_4);
        _this__u8e3s4.hbb(p, view);
        return view;
      }
      wd6(_this__u8e3s4) {
        if (this.fev_1 == null && !(this.eev_1.f2() == null)) {
          this.eev_1.oam(null);
        }
        var tmp = _this__u8e3s4.kbb(_this__u8e3s4.jbb(AuthBackgroundSemantic_getInstance()), get_scrolling(_this__u8e3s4));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (Frame())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        var $this$frame = view;
        launch($this$frame, VOID, VOID, LogInScreen$render$slambda_0(this, $this$frame));
        $this$frame.gba(get_dp(8));
        applySafeInsets($this$frame);
        reactive($this$frame, ($this$reactive) => {
          var tmp;
          if (!($this$reactive.daj(get_rawSession()) == null)) {
            get_pageNavigator($this$frame).gbw(new (LandingScreen())());
            tmp = Unit_instance;
          }
          return Unit_instance;
        });
        var tmp_0 = $this$frame.kbb(get_centered($this$frame), get_padded($this$frame));
        // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
        var breakpoint = get_AppDimensions().vgf();
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowCollapsingToColumn())($this$frame.pc(), listOf(new (Dimension())(breakpoint)));
        var tmp0_elvis_lhs_0 = $this$frame.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? $this$frame : tmp0_elvis_lhs_0;
        $this$frame.gbb(p_0, view_0);
        view_0.lbb(get_centered(view_0), loginBanner(view_0));
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (Space())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.gbb(p_1, view_1);
        view_0.hbb(p_1, view_1);
        var tmp_1 = view_0.kbb(view_0.jbb(AuthDialogSemantic_getInstance()), get_centered(view_0));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (Frame())(view_0.pc());
        var tmp0_elvis_lhs_2 = view_0.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
        view_0.gbb(p_2, view_2);
        view_2.gba(get_AppDimensions().zg1_1);
        var tmp_2 = view_2.kbb(view_2.ibb(get_appTheme()), sizeConstraints(view_2, VOID, VOID, VOID, VOID, VOID, get_rem_0(30)));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (RowOrCol())(view_2.pc());
        var tmp0_elvis_lhs_3 = view_2.ebb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
        view_2.gbb(p_3, view_3);
        view_3.zbm(true);
        view_3.lbb(shownWhen(view_3, VOID, ($this$shownWhen) => !($this$shownWhen.daj(this.eev_1) == null)), body(view_3, 'Please login to continue to your project'));
        view_3.lbb(shownWhen(view_3, VOID, ($this$shownWhen) => $this$shownWhen.daj(this.gev_1) == null && !$this$shownWhen.daj(this.jev_1)), this.hir(view_3));
        view_3.lbb(shownWhen(view_3, VOID, ($this$shownWhen) => !($this$shownWhen.daj(this.hev_1) == null) && !($this$shownWhen.daj(this.iev_1) == null) && !$this$shownWhen.daj(this.jev_1)), this.iir(view_3));
        view_3.lbb(shownWhen(view_3, false, ($this$shownWhen) => $this$shownWhen.daj(this.jev_1)), this.gir(view_3, this.jev_1));
        view_2.hbb(p_3, view_3);
        view_2.lbb(tmp_2, view_3);
        view_0.hbb(p_2, view_2);
        view_0.lbb(tmp_1, view_2);
        $this$frame.hbb(p_0, view_0);
        $this$frame.lbb(tmp_0, view_0);
        _this__u8e3s4.hbb(p, view);
        return _this__u8e3s4.lbb(tmp, view);
      }
    }
    protoOf($).wcv = get_title;
    initMetadataForClass($, 'LogInScreen', LogInScreen, VOID, [Page(), AuthScreen()], [1, 4, 3]);
    LogInScreenClass = $;
  }
  return LogInScreenClass;
}
function loginBanner(_this__u8e3s4) {
  var tmp = sizeConstraints(_this__u8e3s4, VOID, VOID, VOID, VOID, VOID, get_rem_0(30));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(true);
  var tmp0_height = get_rem_0(4);
  var tmp1_width = get_rem(19.135);
  var tmp_0 = view.kbb(sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, tmp1_width, tmp0_height), get_centered(view));
  // Inline function 'com.lightningkite.kiteui.views.direct.image' call
  // Inline function 'kotlin.apply' call
  var this_0 = new (ImageView())(view);
  this_0.qda(Resources_getInstance().xf8_1);
  this_0.bbb();
  view.lbb(tmp_0, this_0);
  var tmp_1 = get_centered(view);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.lba(view_0.qb6_1.abf(BodySemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value = "Contractor's Project Escrow Solution!";
  var tmp_2 = view_0.vb5_1;
  var tmp_3;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value) === 0) {
    tmp_3 = '\xA0';
  } else {
    tmp_3 = value;
  }
  tmp_2.hbu(tmp_3);
  view.hbb(p_0, view_0);
  view.lbb(tmp_1, view_0);
  _this__u8e3s4.hbb(p, view);
  return _this__u8e3s4.lbb(tmp, view);
}
//region block: exports
export {
  AuthScreen as AuthScreen1ogng2fnfjgd9,
  LogInScreen as LogInScreen3qovz4fzwtjwv,
  loginBanner as loginBanner2c3004yosmlht,
};
//endregion

//# sourceMappingURL=LogInScreen.mjs.map
